import {Injectable} from "@angular/core";
import {NestApiProvider} from "../../nest-api";
import {Observable} from "rxjs";
import {RequestAllOvtCancelReportDto, ResponsePreviewDto} from "../dto/overtime-cancel-report.dto";
import {ResponseData} from "../../nest-responses";

@Injectable()
export class OvtCancelReportApi {
  private readonly service: string = '';
  private readonly model: string = 'att/shared/ovtcancelationreport';

  constructor(
    private readonly nestApiProvider: NestApiProvider,
  ) {
  }

  public preview(payload: RequestAllOvtCancelReportDto): Observable<ResponsePreviewDto> {
    const method: string = 'POST';
    const func: string = 'preview';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponsePreviewDto>(method, url, params, urlParams, body);
  }

  public downloadExcel(payload: RequestAllOvtCancelReportDto): Observable<Blob> {
    const method: string = 'POST';
    const func: string = 'downloadExcel';
    const params: any = payload || {};
    const urlParams: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.requestBlob<Blob>(method, url, params);
  }

  public sendMailPdf(payload: RequestAllOvtCancelReportDto): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'sendMailPdf';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public sendMailExcel(payload: RequestAllOvtCancelReportDto): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'sendMailExcel';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public downloadPdf(payload: RequestAllOvtCancelReportDto): Observable<Blob> {
    const method: string = 'POST';
    const func: string = 'downloadPdf';
    const params: any = payload || {};
    const urlParams: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.requestBlob<Blob>(method, url, params);
  }

  public status(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'status';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body, null);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/overtime-cancel-report.api.ts